/**
 * Capitalizes the first letter of a string
 * @param text - The string to capitalize
 * @returns The capitalized string
 * @example
 * capitalize("hello") // "Hello"
 */
export const capitalize = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
